import React, { useState, useRef, useEffect } from 'react';
import translate from '@e4/intl/translate.macro';

import { BurgerMenu as BurgerMenuIcon } from '../assets';
import { ListItem } from '../UnorderedList';
import Submenu from './Submenu/Submenu';

const BurgerIconSize = '1.5rem';

const BurgerMenu = (props) => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [itemHeight, setItemHeight] = useState(true);
  const listItemRef = useRef(null);

  useEffect(() => {
    if (listItemRef.current) {
      setItemHeight(listItemRef.current.offsetHeight);
    }
  }, [listItemRef]);

  return (
    <ListItem ref={listItemRef}>
      <BurgerMenuIcon
        open={menuIsOpen}
        title={translate('webMenu.burgerMenuIcon.ariaLabel')}
        titleId="submenu"
        onClick={() => setMenuIsOpen(!menuIsOpen)}
        width={BurgerIconSize}
        height={BurgerIconSize}
      />
      <Submenu
        items={props.items}
        topOffset={itemHeight}
        visible={menuIsOpen}
      />
    </ListItem>
  );
};

export default BurgerMenu;
